<header class="hero-section">
  <div class="hero-noise"></div>
  <div class="hero-gradient"></div>
  <div class="hero-content">
    <div class="hero-badge">
      <span class="badge-dot"></span>
      Institute Management System
    </div>
    <h1 class="hero-title">
      Complete<br/>
      <span class="title-accent">Institution</span><br/>
      Solutions
    </h1>
    <p class="hero-description">
      Transform your educational institution with our comprehensive management
      platform — built for employees, parents and students.
    </p>
    <div class="hero-actions">
      <a
        routerLink="/login"
        class="btn-primary-hero"
        [class.loading]="isNavigating"
        [attr.aria-disabled]="isNavigating"
        (click)="onLoginClick($event)"
      >
        <span *ngIf="isNavigating" class="loading-spinner"></span>
        <span>{{ isNavigating ? 'Loading...' : 'Goto Login' }}</span>
        <svg
          *ngIf="!isNavigating"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M3 8h10M9 4l4 4-4 4"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
      <a href="https://ainstitute.cloud" class="btn-ghost-hero" target="_blank">
        Explore Platform
      </a>
    </div>
  </div>
  <footer class="hero-footer">
    <p>Proudly supported by <a href="https://nythovadatalab.ai"><strong>Nythova Data Lab LLC</strong></a> — A U.S. registered company</p>
  </footer>
</header>
